import { get } from '.';

export function GetEnrollerRunCriterions(enrollerRunId, options = {}) {
	return get<any>("/app/api/enroller_runs/" +  (enrollerRunId || 0).toString() + "/enroller_run_criterions", options);
}
